import "./Footer.scss";

export default function Footer() {
  return (
    <footer className="app-footer">
      <p>© {new Date().getFullYear()} FluxoEasy</p>
    </footer>
  );
}
